import React, { Component } from "react";
import { Table, Modal } from "react-bootstrap";
var dateFormat = require("dateformat");

class LicenseeView extends Component {

  render() {
    const data = this.props.LicenseeDetailView
      ? this.props.LicenseeDetailView
      : null;

    return (
      <div>
        <div>
          <Modal
            show={this.props.showDetailView}
            onHide={this.props.closeDetailView}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Licensee Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <h6 className="labelStyle">Licensee Details</h6>
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Licensee Name</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.userId.name + " " + data.userId.lName}
                        </td>
                      </tr>
                      <tr>
                        <td>Email Id</td>
                        <td>
                          {data !== null && data.userId && data.userId.email}
                        </td>
                      </tr>
                      <tr>
                        <td>Mobile Number</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            (data.country && data.country.callingCode) +
                              (data.userId && data.userId.mobileNo)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <br />

                  <h6 className="labelStyle">Organization Details</h6>
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Organization</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.orgName}
                        </td>
                      </tr>
                      <tr>
                        <td>Country</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.country && data.country.name}
                        </td>
                      </tr>

                      <tr>
                        <td>Address 1</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.addr1}
                        </td>
                      </tr>
                      <tr>
                        <td>Address 2</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.addr2}
                        </td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.state && data.state.name}
                        </td>
                      </tr>
                      <tr>
                        <td>District</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.district && data.district.name}
                        </td>
                      </tr>
                      <tr>
                        <td>City</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.city}
                        </td>
                      </tr>
                      <tr>
                        <td>Landmark</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.landmark}
                        </td>
                      </tr>
                      <tr>
                        <td>Zip Code</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.zip}
                        </td>
                      </tr>
                      <tr>
                        <td>GSTIN</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.gstin}
                        </td>
                      </tr>
                      {/* <tr>
                        <td>GL Code</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.glCode}
                        </td>
                      </tr>
                      <tr>
                        <td>CR No</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.crNumber}
                        </td>
                      </tr>
                      <tr>
                        <td>CR Expiry Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            dateFormat(data.crExpDate, "mediumDate")}
                        </td>
                      </tr> */}
                    </tbody>
                  </Table>
                  <br />

                  <h6 className="labelStyle">Contact Details</h6>
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Contact Person</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.spocName}
                        </td>
                      </tr>
                      <tr>
                        <td>Contact Email</td>
                        <td>{data !== null && data.spocEmail}</td>
                      </tr>
                      <tr>
                        <td>Designation</td>
                        <td>{data !== null && data.spocDsgntn}</td>
                      </tr>
                      <tr>
                        <td>Contact Number</td>
                        <td>{data !== null && data.spocPhn}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <br />

                  <h6 className="labelStyle">Headquarters Details</h6>
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Address</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.hqAddr}
                        </td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{data !== null && data.hqEmail}</td>
                      </tr>
                      <tr>
                        <td>Fax</td>
                        <td>{data !== null && data.hqFax}</td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td>{data !== null && data.hqPhn}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <br />

                  <h6 className="labelStyle">Tax and Commission</h6>
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Currency Code</td>
                        <td>
                          {data !== null &&
                            data.curncyCode &&
                            data.curncyCode.iso4217Code}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Enabled</td>
                        <td>
                          {data !== null && data.taxEnble === true
                            ? "Enabled"
                            : "Not Enabled"}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Percentage</td>
                        <td>{data !== null && data.taxPrcntg}</td>
                      </tr>
                      <tr>
                        <td>Commission Percentage</td>
                        <td>{data !== null && data.commsnPrcntg}</td>
                      </tr>
                      <tr>
                        <td>Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                      <tr>
                        <td>Updated Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            dateFormat(data.updatedAt, "mediumDate")}
                        </td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.status === "active"
                            ? "Active"
                            : "Suspended"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default LicenseeView;
